export default __webpack_public_path__ + "static/media/Archdeacon's Straps of the Abyss.16e1c816.jpg";